import Vue from 'vue'

const client = Vue.prototype.$api

export default {
    sendAvailabilityRequest (params) {
        return client.post('ProfessionalAvailabilityRequest/SendAvailabilityRequest', params)
    },
    sendServiceAvailabilityRequest (params) {
        return client.post('ProfessionalAvailabilityRequest/SendServiceAvailabilityRequest', params)
    },
    getActivesServices (profId) {
        return client.get('ProfessionalAvailabilityRequest/GetActivesServices', {params: {profId: profId}})
    },
    getActivesCenterToRequestAvailability (profId) {
        return client.get('ProfessionalAvailabilityRequest/GetActivesCenterToRequestAvailability', {params: {profId: profId}})
    }
}


// WEBPACK FOOTER //
// ./src/repositories/ProfessionalAvailabilityRequestRepository.js